var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.23424 13.6667C6.72375 13.75 9.14113 12.823 10.9367 11.0965C12.7322 9.37005 13.7532 6.99086 13.7676 4.5C14.3323 3.80117 14.7516 2.99652 15.0009 2.13333C15.0389 1.99402 14.9916 1.84537 14.8801 1.75364C14.7686 1.6619 14.6136 1.64416 14.4842 1.70833C13.8784 1.99994 13.1541 1.87251 12.6842 1.39166C12.0932 0.744441 11.2653 0.364133 10.3892 0.337443C9.51313 0.310752 8.66358 0.639955 8.03424 1.25C7.16671 2.09016 6.80302 3.32356 7.07591 4.5C4.28424 4.66666 2.36757 3.34166 0.834241 1.525C0.740116 1.4184 0.591866 1.37756 0.456428 1.4209C0.320991 1.46424 0.223997 1.58356 0.209241 1.725C-0.388996 5.04347 1.13996 8.38391 4.04257 10.1C3.09227 11.1899 1.75775 11.8705 0.317574 12C0.159391 12.0262 0.0353878 12.1501 0.00902739 12.3083C-0.017333 12.4665 0.0597824 12.6239 0.200908 12.7C1.45384 13.3261 2.8336 13.6568 4.23424 13.6667Z",
    fill: "#00AAEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.fd73d1f90e94ea9682dfbd0d2876642f.svg";
export { ForwardRef as ReactComponent };